import RaxSlider from 'rax-slider';
const { Item } = RaxSlider;
export default Item;
